import React from 'react';
import '../styles/MenuIcon.css';

const MenuIcon = ({ isOpen }) => {
  return (
    <div className={`hamburger-menu ${isOpen ? 'open' : ''}`}>
      <span className="line line-1"></span>
      <span className="line line-2"></span>
      <span className="line line-3"></span>
    </div>
  );
};

export default MenuIcon; 